import useFeaturesCustomization from "./useFeaturesCustomization";
const useFeatureCustomization = (feature) => {
  var _a;
  const featuresCustomization = useFeaturesCustomization();
  return {
    enabled: ((_a = featuresCustomization == null ? void 0 : featuresCustomization[feature]) == null ? void 0 : _a.enabled) !== false
  };
};
export default useFeatureCustomization;
